/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionRegionEnum } from './subscriptionRegionEnum';
import { BillingFrequencyEnum } from './billingFrequencyEnum';
import { ChargeIdEnum } from './chargeIdEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { OfferCategoryEnum } from './offerCategoryEnum';
import { DataCentersEnum } from './dataCentersEnum';
import { SubscriptionTypeEnum } from './subscriptionTypeEnum';
import { ChargeTypeEnum } from './chargeTypeEnum';
import { BillingTermUomEnum } from './billingTermUomEnum';
import { CustomerSegmentEnum } from './customerSegmentEnum';
import { RouteToMarketEnum } from './routeToMarketEnum';
import { BillingModelEnum } from './billingModelEnum';
import { CurrencyEnum } from './currencyEnum';


export interface SubscriptionV2OfferRequest { 
    /**
     * Billing account ID of the seller
     */
    billing_account_id: string;
    billing_frequency?: BillingFrequencyEnum;
    billing_model?: BillingModelEnum;
    /**
     * Applicable only for COMMIT
     */
    billing_term?: number;
    billing_term_uom?: BillingTermUomEnum;
    charge_id?: ChargeIdEnum;
    charge_type?: ChargeTypeEnum;
    currency: CurrencyEnum;
    customer_segment: CustomerSegmentEnum;
    datacenter: DataCentersEnum;
    /**
     * Offer description from billing engine
     */
    description?: string;
    /**
     * Idempotency key of the offer request
     */
    idempotency_key: string;
    /**
     * offer name
     */
    name: string;
    offer_category: OfferCategoryEnum;
    offer_type: SubscriptionTypeEnum;
    /**
     * Globally unique product id from Offer response
     */
    product_id: string;
    /**
     * quantity for purchase. Applicable only for COMMIT
     */
    purchase_quantity: number;
    region: SubscriptionRegionEnum;
    /**
     * Time at which offer needs to get activated
     */
    requested_start_date: Date;
    route_to_market: RouteToMarketEnum;
    seller: string;
    service_type: ServiceTypeEnum;
    /**
     * The total list price (MSRP) at this grouping level.
     */
    total_list_price?: number;
}
export namespace SubscriptionV2OfferRequest {
}


